import _ from 'lodash';

export default class EndpointUtils {
    /**
     * Returns the color in which to render a device's icon, given the status (value) of a device.
     *
     * @param value the status of the device
     * @returns {string} the icon color. for example, 'red' to indicate an off-line/troubled device;
     * 'green' to indicate a healthy device.
     */
    static calculateColor(value, type) {
        if (value) {
            if (type) {
                let results = 'gray';
                value.forEach( v => {
                    if (v.type === type) {
                        if (v.status.toLowerCase() === 'up') {
                            if (results === 'red' || results === 'yellow') {
                                results = 'yellow';
                            } else {
                                results = 'green';
                            }
                        } else if (v.status.toLowerCase() === 'down') {
                            if (results === 'green' || results === 'yellow') {
                                results = 'yellow';
                            } else {
                                results = 'red';
                            }
                        }
                    }
                });
                return results;
            }
            else if (value.toLowerCase() === 'up') {
                return 'green';
            } else if (value.toLowerCase() === 'down') {
                return 'red';
            } else {
                var obj = {};
                var tokens = value.split(' | ');
                _.forEach(tokens,  function (token) {
                    var values = token.split('=');
                    if (values && values.length === 2) {
                        obj[_.camelCase(values[0])] = _.lowerCase(values[1]);
                    }
                });
                if (obj.notConnected && obj.notConnected === 'none' && obj.connected && obj.connected === 'none') {
                    return 'gray';
                } else if (obj.notConnected && obj.notConnected === 'none' && (obj.connected || obj.connected === 0) && obj.connected !== 'none' && obj.connected !== 'null') {
                    return 'green';
                } else if (obj.connected && obj.connected === 'none') {
                    return 'red';
                } else if ((obj.notConnected || obj.notConnected === 0) && obj.notConnected !== 'none' && (obj.connected || obj.connected === 0) && obj.connected !== 'none') {
                    return 'yellow';
                }
            }
        }
        return 'gray';
    }
}
